export default __webpack_public_path__ + "static/img/bubble-2@2x.63d3a0.png";